// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
class VehiclePositionRecord extends VerofreshRecord {
}

const relations = {
  belongsTo: {
    Location: {
      foreignKey: 'location_id',
      localField: 'location'
    },
    Vehicle: {
      foreignKey: 'vehicle_id',
      localField: 'vehicle'
    }
  }
}

export default VehiclePositionRecord
export { relations }
